import Home from "../pages/Home";
import Mine from "../pages/Mine";
import RWA from "../pages/RWA";
import RwaMine from "../pages/RwaMine";
import HistoryDeai from "../pages/HistoryDeai";
import HistoryLP from "../pages/HistoryLP";
import HistoryYeJi from "../pages/HistoryYeJi";
import Text from "../pages/Text";
const routes = [
  {
    path: "/",
    component: RWA,
  },
  {
    path: "/stake",
    component: Home,
  }, {
    path: "/mine/:invite?",
    component: Mine,
  }, {
    path: "/rwa",
    component: RWA,
  }, {
    path: "/rwamine/:invite?",
    component: RwaMine,
  }, {
    path: "/historydeai",
    component: HistoryDeai,
  }, {
    path: "/historylp",
    component: HistoryLP,
  }, {
    path: "/historyyeji",
    component: HistoryYeJi,
  }, {
    path: "/text",
    component: Text,
  }
];

export default routes;
